// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"b3ca52b1","964":"22486faa"}[chunkId] + ".chunk.css";
};